var React = require('react');

function PlaceholderChart (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},[React.createElement("radialGradient",{"id":"a","key":0},[React.createElement("stop",{"offset":"50%","stopColor":"#fff","key":0}),React.createElement("stop",{"offset":"100%","stopColor":"#fff","stopOpacity":"0","key":1})]),React.createElement("mask",{"id":"b","key":1},React.createElement("path",{"fill":"url(#a)","d":"M0 0h672v274H0z"}))]),React.createElement("path",{"fill":"none","stroke":"#E1E8EF","d":"M0 251.7h671.2M0 210h671.2M0 168.2h671.2M0 126.5h671.2M0 84.5h671.2M0 42.9h671.2M0 1h671.2M39.4 1v271.7M89 1v271.7M138.8 1v271.7M188.6 1v271.7M238.2 1v271.7M288 1v271.7M337.7 1v271.7M387.4 1v271.7M437 1v271.7M486.9 1v271.7M536.6 1v271.7M586.3 1v271.7M636 1v271.7","mask":"url(#b)","key":1})]);
}

PlaceholderChart.defaultProps = {"width":"672","height":"274"};

module.exports = PlaceholderChart;

PlaceholderChart.default = PlaceholderChart;



//////////////////
// WEBPACK FOOTER
// ./src/components/LineChartWrapper/placeholderChart.svg
// module id = 935
// module chunks = 0